






























import { Component } from 'vue-property-decorator';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import EsServices from '@/services/es';
import { sleep } from '@/libs/util';
@Component({
  components: {}
})
export default class Cards extends mixins(DictMixin) {
  esSrv = new EsServices();

  created() {
    this.getList();
    this.createData();
  }

  list: any = [];
  cards: any[] = [];
  async getList() {
    let res: any = await this.esSrv.search('sub_sdm_rpt_opr_exe_ops_ind', { page: 1, limit: 10, sort: 'year' });
    let data = res.list.map((v: any) => v.sourceAsMap);
    if (!data || data.length < 3) return false;
    let [current, lastYear, last2Year] = data;
    console.log(current);
    this.list = [
      {
        title: '风险调整后资本收益率（RAROC）',
        value: parseInt(current.raroc),
        lastyear: lastYear.year,
        lastyearValue: parseInt(lastYear.raroc),
        last2Year: last2Year.year,
        last2YearValue: parseInt(last2Year.raroc),
        type: 'ring'
      },
      {
        title: '操作风险损失',
        value: parseInt(current.ops_risk_loss),
        lastyear: lastYear.year,
        lastyearValue: parseInt(lastYear.ops_risk_loss),
        last2Year: last2Year.year,
        last2YearValue: parseInt(last2Year.ops_risk_loss),
        type: 'ring'
      },
      {
        title: '流失率',
        value: parseInt(current.loss_rate),
        lastyear: lastYear.year,
        lastyearValue: parseInt(lastYear.loss_rate),
        last2Year: last2Year.year,
        last2YearValue: parseInt(last2Year.loss_rate),
        type: 'ring'
      },
      {
        title: '单位交易成本',
        value: parseInt(current.cpt),
        lastyear: lastYear.year,
        lastyearValue: parseInt(lastYear.cpt),
        last2Year: last2Year.year,
        last2YearValue: parseInt(last2Year.cpt),
        type: 'ring'
      },
      {
        title: '成本收入比',
        value: parseInt(current.cpr),
        lastyear: lastYear.year,
        lastyearValue: parseInt(lastYear.cpr),
        last2Year: last2Year.year,
        last2YearValue: parseInt(last2Year.cpr),
        type: 'ring'
      },
      {
        title: '每位员工服务活跃客户数',
        value: parseInt(current.service_cnt),
        lastyear: lastYear.year,
        lastyearValue: parseInt(lastYear.service_cnt),
        last2Year: last2Year.year,
        last2YearValue: parseInt(last2Year.service_cnt),
        type: 'flop'
      }
    ];
  }

  async createData() {
    if (this.list.length < 3) {
      await sleep(100);
      this.createData();
      return false;
    }
    const data: any = this.list;
    this.cards = new Array(6).fill(0).map((_, i) => ({
      title: data[i].title,
      type: data[i].type,
      value: data[i].value,
      lastyear: data[i].lastyear,
      lastyearValue: data[i].lastyearValue,
      last2YearValue: data[i].last2YearValue,
      last2Year: data[i].last2Year,
      ring: {
        series: [
          {
            type: 'gauge',
            startAngle: -Math.PI / 2,
            endAngle: Math.PI * 1.5,
            arcLineWidth: 13,
            radius: '80%',
            data: [{ name: '比率', value: data[i].value }],
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {
              show: false
            },
            backgroundArc: {
              style: {
                stroke: '#224590'
              }
            },
            details: {
              show: true,
              formatter: '{value}%',
              style: {
                fill: '#1ed3e5',
                fontSize: 20
              }
            }
          }
        ],
        color: ['#03d3ec']
      }
    }));
  }
}
